<span [style.paddingRight]="100 * (max - value) / (max - min) + '%'"></span>
